import { useParams } from 'react-router-dom';
import { SELECTED_ITEM_QUERY_KEY } from 'src/constants';

export const useSubmissionId = () => {
  const { submissionId: paramId = '' } = useParams();

  const searchParams = new URLSearchParams(location.search);
  const selectedItem = searchParams.get(SELECTED_ITEM_QUERY_KEY);
  const submissionId = selectedItem || paramId;

  return submissionId || null;
};
